module.exports = __webpack_public_path__ + "img/card_open.4ba6f51b.svg";